export default __webpack_public_path__ + "static/media/superior-closing-logo--icon-only.fbb86129.png";